export function isFileFormatValid(name: string, formatList: string[]) {
	return formatList.some((format) => name.includes(format));
}
